import { useContext } from 'react';
import VehicleContext from '~/context/vdp/VehicleContext';
import useShowVaultWhyBuyContent from './useHasVaultWhyBuyData';

export default function useShowWhyBuyContent(): boolean {
  const vaultWhyBuyContentExists = useShowVaultWhyBuyContent();
  const {
    ymmtWhyBuy: { data, isLoaded, hasError }
  } = useContext(VehicleContext);

  const ymmtWhyBuyContentExists =
    isLoaded &&
    !hasError &&
    Boolean(data.summary) &&
    Array.isArray(data.bulletPoints) &&
    data.bulletPoints.length > 0;

  return vaultWhyBuyContentExists || ymmtWhyBuyContentExists;
}
